export const MLABS_TRANSLATOR_ON_CHANGE_LANGUAGE = 'ml-translator-on-change-language';
